// Components
import { AddPlaylistButton } from './AddPlaylistButton';
import { CloseIcon, LibraryCollapsedIcon, LibraryIcon, LibraryExpandIcon, LibraryCollapseIcon, ExpandIcon } from '../../../Icons';

// Utils
import { memo, useState } from 'react';

// Components
import { Flex, Space } from 'antd';
import { Tooltip } from '../../../Tooltip';

// I18n
import { useTranslation } from 'react-i18next';

// Redux
import { getLibraryCollapsed, uiActions } from '../../../../store/slices/ui';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

const isMobile = window.innerWidth < 900;

const CloseButton = () => {
  const dispatch = useAppDispatch();

  return (
    <div className='playing-section-close-button'>
      <button
        onClick={() => {
          dispatch(uiActions.collapseLibrary());
        }}
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export const LibraryTitle = memo(() => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['navbar']);
  const collapsed = useAppSelector(getLibraryCollapsed);
  const [isHovered, setIsHovered] = useState(false);
  console.log('Title.tsx loaded, cache cleared');

  if (collapsed) {
    return (
      <Tooltip placement='right' title={t('Expand your library')}>
        <button
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => dispatch(uiActions.toggleLibrary())}
        >
          <div style={{ position: 'relative', width: 25, height: 25 }}>
            <div style={{ position: 'absolute', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', opacity: isHovered ? 0 : 1, transition: 'opacity 0.2s ease-in-out' }}>
              <LibraryCollapsedIcon />
            </div>
            <div style={{ position: 'absolute', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', opacity: isHovered ? 1 : 0, transition: 'opacity 0.2s ease-in-out' }}>
              <LibraryExpandIcon size={24} />
            </div>
          </div>
        </button>
      </Tooltip>
    );
  }

  return (
    <Flex align='center' justify='space-between' style={{ padding: '0 8px 0 0px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className="library-collapse-button-wrapper">
          <Tooltip placement='top' title={t('Collapse your library')}>
            <button className="library-collapse-button" style={{ fontSize: '112%' }} onClick={() => dispatch(uiActions.toggleLibrary())}>
              <LibraryCollapseIcon size="1em" />
            </button>
          </Tooltip>
        </div>
        <span className='Navigation-button' style={{ color: '#fff', fontWeight: 700, fontSize: '112%', transition: 'color 0.2s ease', cursor: 'pointer' }} onMouseEnter={(e) => e.currentTarget.style.color = '#fff'} onMouseLeave={(e) => e.currentTarget.style.color = '#fff'}>{t('Your Library')}</span>
      </div>

      {isMobile ? <CloseButton /> : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <AddPlaylistButton />
          <Tooltip placement='top' title={t('Show more')}>
            <button className="library-expand-button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: '#b3b3b3', cursor: 'pointer', padding: '8px', borderRadius: '50%' }} onMouseEnter={(e) => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.backgroundColor = '#2a2a2a'; }} onMouseLeave={(e) => { e.currentTarget.style.color = '#b3b3b3'; e.currentTarget.style.backgroundColor = 'transparent'; }}>
              <ExpandIcon />
            </button>
          </Tooltip>
        </div>
      )}
    </Flex>
  );
});

